import { ActionTypes } from '../actions';
import { IGroup, IDocument } from '../types';

export interface IGroupState {
  [documentId: string]: {
    [pageNumber: number]: {
      [groupId: string]: IGroup;
    };
  };
}

export default (state: IGroupState = {}, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_ENVELOPE_DONE: {
      const envelope = action.payload;
      const groups: IGroupState = {};
      envelope.documents.forEach((doc: IDocument) => {
        const { blockGroups: currentGroups } = doc;
        if (currentGroups) {
          currentGroups.forEach(group => {
            if (!groups[group.documentId]) {
              groups[group.documentId] = {};
            }
            if (!groups[group.documentId][group.pageNumber]) {
              groups[group.documentId][group.pageNumber] = {};
            }
            groups[group.documentId][group.pageNumber][group.id] = group;
          });
        }
      });
      return groups;
    }
    default: {
      return state;
    }
  }
};
